
import * as React from 'react';
import { BaseComponent } from '../BaseComponent';
import { VisibilityActions } from '../../actions/VisibilityActions';
import { Overlay } from '../../constants/Enums';

interface OverlayCloseButtonProps {
    show: boolean;
    callback?: () => void;
}

interface OverlayCloseButtonState {
}

export class OverlayCloseButton extends BaseComponent<OverlayCloseButtonProps, OverlayCloseButtonState> {
    public render(): JSX.Element | null {
        if (!this.props.show) {
            return null;
        }
        return (
            <div className="overlay-close-button" onClick={this.onClose}/>
        );
    }

    protected onClose = (event: React.MouseEvent): void => {
        try {
            (event.currentTarget as HTMLElement).focus();
        } catch (e) { /* */ }
        if (this.props.callback) {
            this.props.callback();
        } else {
            VisibilityActions.changeOverlay(Overlay.NONE);
        }
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/overlay/OverlayCloseButton.tsx